module.exports = __webpack_public_path__ + "media/images/logo_wu-e26afe0db33f41a0c58838501d8937ab.png";